import {createContext} from 'react';

const movimientosContext = createContext();

export default movimientosContext;